module.exports = require("frontend-platform_detection/config/domains.json");